(function () {
  'use strict';

  // Find the hero by class (works regardless of unique section ID)
  const heroEl = document.querySelector('.hero-video');
  const whiteFade = document.querySelector('[data-hero-white-fade]');
  const scrollHint = document.querySelector('[data-scroll-hint]');
  const headlineEl = document.querySelector('.headline-statement');

  // ── Scroll-driven video → white fade ────────────────────────
  function onScroll() {
    if (!heroEl) return;

    const heroH    = heroEl.offsetHeight;
    const scrollY  = window.scrollY;

    // Fade white overlay over the LAST half of the hero scroll
    const fadeStart = heroH * 0.5;
    const fadeEnd   = heroH * 0.95;
    let fadeProgress = 0;

    if (scrollY > fadeStart) {
      fadeProgress = Math.min((scrollY - fadeStart) / (fadeEnd - fadeStart), 1);
    }

    if (whiteFade) {
      whiteFade.style.opacity = fadeProgress;
    }

    // Hide scroll hint as soon as user starts scrolling
    if (scrollHint) {
      scrollHint.style.opacity = Math.max(1 - scrollY / 120, 0);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ── Scroll fade-in for dark sections ────────────────────────
  const fadeTargets = document.querySelectorAll('.mission-bar, .shop-banner, .who-we-serve, .contact-cta');
  if ('IntersectionObserver' in window && fadeTargets.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    fadeTargets.forEach((el) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.8s cubic-bezier(0.16,1,0.3,1), transform 0.8s cubic-bezier(0.16,1,0.3,1)';
      observer.observe(el);
    });
  }
})();
